import { render } from "./StarDarkSvg.vue?vue&type=template&id=555f6226"
import script from "./StarDarkSvg.vue?vue&type=script&lang=js"
export * from "./StarDarkSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__